const Mutations = Object.freeze({
	SET_INITIALIZED: 'projectManagement/SET_INITIALIZED',
	SET_PROJECTS: 'projectManagement/SET_PROJECTS',
	SET_SELECTED_PROJECT: 'projectManagement/SET_SELECTED_PROJECT',
	SET_DBCONNECTION: 'projectManagement/SET_DBCONNECTION',
	SET_LOADING: 'projectManagement/SET_LOADING',
	SET_PROJECTSBYUSER: 'projectManagement/SET_PROJECTSBYUSER',
	SET_MOBILE_ACCESS_CODES: 'projectManagement/SET_MOBILE_ACCESS_CODES',
	SET_MOBILE_DEVICES: 'projectManagement/SET_MOBILE_DEVICES',
	SET_MOBILE_LOADING: 'projectManagement/SET_MOBILE_LOADING',
});
export const Actions = Object.freeze({
	LOAD_DATA: 'projectManagement/LOAD_DATA',
	LOAD_DATA_PROJECTID: 'projectManagement/LOAD_DATA_PROJECTID',
	LOAD_DB_BYCLIENTNAME: 'projectManagement/LOAD_DB_BYCLIENTNAME',
	CREATE_INTEGRATION_API_LEY: 'projectManagement/CREATE_INTEGRATION_API_KEY',
	INSERT_PROJECT: 'projectManagement/INSERT_PROJECT',
	INSERT_DBCON: 'projectManagement/INSERT_DBCON',
	UPDATE: 'projectManagement/UPDATE',
	UPDATE_DBCON: 'projectManagement/UPDATE_DBCON',
	DELETE: 'projectManagement/DELETE',
	REMOVE_LOGO: 'projectManagement/REMOVE_LOGO',
	CLEAR: 'projectManagement/CLEAR',
	CLEAR_SELECTEDPROJECT: 'projectManagement/CLEAR_SELECTEDPROJECT',
	LOAD_MOBILE_ACCESS_CODES: 'projectManagement/LOAD_MOBILE_ACCESS_CODES',
	GENERATE_MOBILE_ACCESS_CODE: 'projectManagement/GENERATE_MOBILE_ACCESS_CODE',
	REVOKE_MOBILE_ACCESS_CODE: 'projectManagement/REVOKE_MOBILE_ACCESS_CODE',
	LOAD_MOBILE_DEVICES: 'projectManagement/LOAD_MOBILE_DEVICES',
	SET_MOBILE_DEVICE_STATUS: 'projectManagement/SET_MOBILE_DEVICE_STATUS',
});
export const Getters = Object.freeze({
	GRID_LOADING: 'projectManagement/GRID_LOADING',
	GET_DATA: 'projectManagement/GET_DATA',
	GET_DBCONNECTION: 'projectManagement/GET_DBCONNECTION',
	GET_SELECTED_PROJECT: 'projectManagement/GET_SELECTED_PROJECT',
	INITIALIZED: 'projectManagement/INITIALIZED',
	GET_MOBILE_ACCESS_CODES: 'projectManagement/GET_MOBILE_ACCESS_CODES',
	GET_MOBILE_DEVICES: 'projectManagement/GET_MOBILE_DEVICES',
	MOBILE_LOADING: 'projectManagement/MOBILE_LOADING',
});

import dataService from '../../../../services/projectManagementService.js';
import { GeneralActions } from '../../../actions';

export default {
	state: {
		initialized: true,
		loading: false,
		projects: [],
		selectedProject: null,
		dbConnection: null,
		projectsByUser: [],
		mobileAccessCodes: [],
		mobileDevices: [],
		mobileLoading: false,
	},
	mutations: {
		[Mutations.SET_INITIALIZED](state, value) {
			state.initialized = value;
		},
		[Mutations.SET_PROJECTS](state, items) {
			state.projects = items;
		},
		[Mutations.SET_SELECTED_PROJECT](state, item) {
			state.selectedProject = item;
		},
		[Mutations.SET_DBCONNECTION](state, item) {
			state.dbConnection = item;
		},
		[Mutations.SET_LOADING](state, loading) {
			state.loading = loading;
		},
		[Mutations.SET_PROJECTSBYUSER](state, items) {
			state.projectsByUser = items;
		},
		[Mutations.SET_MOBILE_ACCESS_CODES](state, items) {
			state.mobileAccessCodes = items;
		},
		[Mutations.SET_MOBILE_DEVICES](state, items) {
			state.mobileDevices = items;
		},
		[Mutations.SET_MOBILE_LOADING](state, loading) {
			state.mobileLoading = loading;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_SELECTED_PROJECT, null);
				commit(Mutations.SET_DBCONNECTION, null);
				commit(Mutations.SET_PROJECTS, []);
				commit(Mutations.SET_LOADING, false);
				resolve();
			});
		},
		[Actions.CLEAR_SELECTEDPROJECT]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_SELECTED_PROJECT, null);
				commit(Mutations.SET_DBCONNECTION, null);
				commit(Mutations.SET_MOBILE_ACCESS_CODES, []);
				commit(Mutations.SET_MOBILE_DEVICES, []);
				resolve();
			});
		},
		[Actions.LOAD_MOBILE_ACCESS_CODES]({ commit, dispatch }, projectId) {
			return new Promise((resolve) => {
				commit(Mutations.SET_MOBILE_LOADING, true);
				dataService
					.getMobileAccessCodes(projectId)
					.then((resp) => {
						commit(Mutations.SET_MOBILE_ACCESS_CODES, resp.data);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						commit(Mutations.SET_MOBILE_LOADING, false);
					});
			});
		},
		[Actions.GENERATE_MOBILE_ACCESS_CODE]({ dispatch }, param) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.generateMobileAccessCode(param)
					.then((resp) => {
						dispatch(
							Actions.LOAD_MOBILE_ACCESS_CODES,
							param.ProjectId
						);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.REVOKE_MOBILE_ACCESS_CODE]({ dispatch }, { id, projectId }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.revokeMobileAccessCode(id)
					.then(() => {
						dispatch(Actions.LOAD_MOBILE_ACCESS_CODES, projectId);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_MOBILE_DEVICES]({ commit, dispatch }, projectId) {
			return new Promise((resolve) => {
				commit(Mutations.SET_MOBILE_LOADING, true);
				dataService
					.getMobileDevices(projectId)
					.then((resp) => {
						commit(Mutations.SET_MOBILE_DEVICES, resp.data);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						commit(Mutations.SET_MOBILE_LOADING, false);
					});
			});
		},
		[Actions.SET_MOBILE_DEVICE_STATUS](
			{ dispatch },
			{ id, status, projectId }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.setMobileDeviceStatus(id, status)
					.then(() => {
						dispatch(Actions.LOAD_MOBILE_DEVICES, projectId);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_DATA]({ commit, dispatch }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				dataService
					.getAllProjects()
					.then((resp) => {
						commit(Mutations.SET_PROJECTS, resp.data);
						commit(Mutations.SET_LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD_DATA_PROJECTID]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getByIdProject(id)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_PROJECT, resp.data);
						if (resp.data.DbConnection) {
							commit(
								Mutations.SET_DBCONNECTION,
								resp.data.DbConnection
							);
						}
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.CREATE_INTEGRATION_API_LEY]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.createIntegrationApiKey(id)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_PROJECT, resp.data);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.INSERT_PROJECT]({ commit, dispatch }, project) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let formData = new FormData();
				formData.append('item', JSON.stringify(project.item));
				if (project.logo) {
					formData.append('file', project.logo);
				}
				dataService
					.insertProject(formData)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_PROJECT, resp.data);
						if (resp.data.DbConnection) {
							commit(
								Mutations.SET_DBCONNECTION,
								resp.data.DbConnection
							);
						}
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						console.error(error);
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.INSERT_DBCON]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertProjectDbCon(item)
					.then((resp) => {
						commit(Mutations.SET_DBCONNECTION, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD_DB_BYCLIENTNAME]({ dispatch }, name) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getDbByName(name)
					.then((resp) => {
						dispatch(GeneralActions.LOADING, false);
						if (!resp.data) {
							dispatch(
								GeneralActions.ERROR,
								'Database name already exists'
							);
							resolve(false);
						}
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.UPDATE]({ commit, dispatch }, project) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let formData = new FormData();
				formData.append('item', JSON.stringify(project.item));
				if (project.logo) {
					formData.append('file', project.logo);
				}
				dataService
					.updateProject(formData, project.item.Id)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_PROJECT, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.UPDATE_DBCON]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateProjectDbCon(item)
					.then(() => {
						commit(Mutations.SET_DBCONNECTION, item);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.REMOVE_LOGO]({ commit, dispatch }, project) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.removeProjectLogo(project.Id)
					.then(() => {
						project.Logo = null;
						commit(Mutations.SET_SELECTED_PROJECT, project);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.DELETE]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteProject(id)
					.then(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
	},
	getters: {
		[Getters.INITIALIZED]: (state) => {
			return state.initialized;
		},
		[Getters.GRID_LOADING]: (state) => {
			return state.loading;
		},
		[Getters.GET_PROJECTSBYUSER]: (state) => {
			return state.projectsByUser;
		},
		[Getters.GET_DATA]: (state) => {
			if (state.projects && state.projects.length > 0) {
				return JSON.parse(
					JSON.stringify(
						state.projects.sort((a, b) =>
							a.Name > b.Name ? 1 : -1
						)
					)
				);
			}
		},
		[Getters.GET_SELECTED_PROJECT]: (state) => {
			if (state.selectedProject) {
				return JSON.parse(JSON.stringify(state.selectedProject));
			}
			return null;
		},
		[Getters.GET_DBCONNECTION]: (state) => {
			if (state.dbConnection) {
				return JSON.parse(JSON.stringify(state.dbConnection));
			}
			return null;
		},
		[Getters.GET_MOBILE_ACCESS_CODES]: (state) => {
			return state.mobileAccessCodes;
		},
		[Getters.GET_MOBILE_DEVICES]: (state) => {
			return state.mobileDevices;
		},
		[Getters.MOBILE_LOADING]: (state) => {
			return state.mobileLoading;
		},
	},
};
